import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';
import { isFeatureEnabled } from 'owa-feature-flags';
import { addDays, OwaDate, userDate, now } from 'owa-datetime';
import updateRecurrenceEnd from 'owa-recurrence-utils/lib/updateRecurrenceEnd';
import getRecurrenceEndDate from 'owa-recurrence-utils/lib/getRecurrenceEndDate';
import { setRecurrence } from 'owa-calendar-compose-form-actions';

/**
 * These are related to events on group calendar
 * @param event : The subject event
 */
export default (event: CalendarEvent): InfoBarMessageViewState[] => {
    const showOutOfBookingWindowInfoBar = isFeatureEnabled(
        'cal-mf-recurringBookingOutOfPolicyInfoBar'
    );

    if (showOutOfBookingWindowInfoBar) {
        if (!event.Recurrence || !event.Resources || event.Resources.length == 0) {
            return [];
        }

        const maxAllowedRecurrenceEndDate: OwaDate = addDays(now(), 180);
        let endDate = getRecurrenceEndDate(event.Start.tz, event.Recurrence);
        if (
            userDate(event.Recurrence.RecurrenceRange.StartDate) > maxAllowedRecurrenceEndDate ||
            !endDate ||
            endDate > maxAllowedRecurrenceEndDate
        ) {
            return [
                InfoBarViewStates.getOutOfRoomBookingWindowPolicy({
                    onChangeEndDateClicked: () => {
                        setRecurrence(
                            updateRecurrenceEnd(event.Recurrence, maxAllowedRecurrenceEndDate)
                        );
                    },
                }),
            ];
        }
    }

    return [];
};
